// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
	lazyIndex: 0,
	lastLazyLoadedIndex: 0,
}

const mutations = make.mutations(state)
const actions = make.actions(state)
const getters = {}

export default {
	name: 'autoLazy',
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
